import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonRef", "options", "open", "onOpenChange", "dropdownStyles", "buttonStyles"];
import { useRef, useEffect, useCallback } from 'react';
import { Dropdown } from './Dropdown';
import { Controllable } from '../Controllable';
import { renderMenu } from './utils/renderMultiLevelMenu';
import { useIsKeyboardMode } from '../../../components/AppProvider/KeyboardModeProvider';
import usePrevious from 'react-utils/hooks/usePrevious';
import { jsx as _jsx } from "react/jsx-runtime";
export const UncontrolledMultiLevelDropdown = _ref => {
  let {
      buttonRef: externalButtonRef,
      options,
      open = false,
      onOpenChange,
      dropdownStyles,
      buttonStyles
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const internalButtonRef = useRef(null);
  const buttonRef = externalButtonRef || internalButtonRef;
  const isKeyboardMode = useIsKeyboardMode();
  const prevOpen = usePrevious(open);
  const optionsRef = useRef(options);
  // eslint-disable-next-line react-hooks/refs
  optionsRef.current = options;
  useEffect(() => {
    if (prevOpen === true && open === false && isKeyboardMode) {
      var _buttonRef$current;
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }
  }, [open, buttonRef, isKeyboardMode, prevOpen]);

  // stable functional component; when it renders it uses the most recent `options`
  const MenuContent = useCallback(() => renderMenu(optionsRef.current), []);
  return /*#__PURE__*/_jsx(Dropdown, Object.assign({}, rest, {
    dropdownStyles: dropdownStyles,
    buttonStyles: buttonStyles,
    animateOnToggle: false,
    buttonRef: buttonRef,
    Content: MenuContent,
    open: open,
    onOpenChange: onOpenChange
  }));
};
const defaultProps = {
  open: false
};
export const MultiLevelDropdown = Controllable(UncontrolledMultiLevelDropdown, ['open'], defaultProps);
MultiLevelDropdown.displayName = 'MultiLevelDropdown';